
import Header from '../../organisms/Header'
import Footer from '../../organisms/Footer'

interface Props {
  children?: React.ReactNode
}

const Layout = ({children}: Props) => {

  return (<>
    <Header />
    <div className="wrapper">
      <div className="container mx-auto">
        <main>
          {children}
        </main>
      </div>
    </div>
    <Footer />
  </>)
}

export default Layout
